module.exports = __webpack_public_path__ + "static/media/money.5f2f97a4.png";